<div class="backpage-wrapper">
  <div class="credential-library-container">
    <div class="header">
      <img
        src="../../../../assets/Logos/IQ toolbox logo.png"
        alt="Stanley IQ logo"
        width="50"
        height="50"
        onerror="this.style.display='none'"
      />
      <h1>Stanley IQ Toolbox Subscriptions - Admin Portal</h1>
    </div>
    <br />
    <div class="sat-table-section">
      <div class="tabs-header-wrapper">
        <mat-tab-group
          [(selectedIndex)]="selectedTabIndex"
          (selectedIndexChange)="onTabChange($event)"
        >
          <!-- Tab 1: Pending Subscriptions -->
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="tab-icon">schedule</mat-icon>
              Subscriptions Pending Payment
            </ng-template>
            <div class="tab-content">
              <div class="tab-description">
                <mat-icon>info_outline</mat-icon>
                <p>
                  Subscriptions configured by admin and sent to purchasers
                  awaiting payment completion.
                </p>
              </div>
              <mat-table
                #table
                [dataSource]="dataSource"
                matSort
                #pendingSort="matSort"
                class="fixed-table"
              >
                <!-- Date Column -->
                <ng-container matColumnDef="dateCreated">
                  <mat-header-cell
                    class="header-cell date-column-header"
                    *matHeaderCellDef
                  >
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>Date Modified</mat-label>
                      <input
                        matInput
                        [matDatepicker]="picker"
                        placeholder="Search Date"
                      />
                      <mat-datepicker-toggle
                        matSuffix
                        [for]="picker"
                      ></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" class="date-column">
                    {{
                      element.dateCreated
                        ? (element.dateCreated | date: "MM/dd/yyyy")
                        : "No Date Provided"
                    }}
                  </mat-cell>
                </ng-container>

                <!-- Company Name Column -->
                <ng-container matColumnDef="subscriptionIdentifier">
                  <mat-header-cell class="header-cell" *matHeaderCellDef>
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>Company Name</mat-label>
                      <input matInput placeholder="Search" />
                    </mat-form-field>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    {{ element.subscriptionIdentifier || "N/A" }}
                  </mat-cell>
                </ng-container>

                <!-- Product Column -->
                <ng-container matColumnDef="productName">
                  <mat-header-cell class="header-cell" *matHeaderCellDef>
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>Product Name</mat-label>
                      <input matInput placeholder="Search" />
                    </mat-form-field>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    {{ element.productName || "N/A" }}
                  </mat-cell>
                </ng-container>

                <!-- Components Column -->
                <ng-container matColumnDef="configuredComps">
                  <mat-header-cell class="header-cell" *matHeaderCellDef>
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>Components</mat-label>
                      <input matInput placeholder="Search" />
                    </mat-form-field>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    {{ element.configuredComps || "N/A" }}
                  </mat-cell>
                </ng-container>

                <!-- Purchaser Email Column -->
                <ng-container matColumnDef="purchaserEmail">
                  <mat-header-cell
                    class="header-cell purchaser-email-header"
                    *matHeaderCellDef
                  >
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>Purchaser Email</mat-label>
                      <input matInput placeholder="Search" />
                    </mat-form-field>
                  </mat-header-cell>
                  <mat-cell
                    *matCellDef="let element"
                    class="purchaser-email-cell"
                  >
                    <span class="email-text">{{
                      element.purchaserEmail || "N/A"
                    }}</span>
                  </mat-cell>
                </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                  <mat-header-cell
                    class="header-cell actions-column-header"
                    *matHeaderCellDef
                  ></mat-header-cell>
                  <mat-cell *matCellDef="let element" class="actions-column">
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="moreMenu"
                      color="accent"
                    >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #moreMenu="matMenu">
                      <button
                        mat-menu-item
                        (click)="navigateToEdit(element.recordId)"
                      >
                        <mat-icon>edit</mat-icon><span>Edit</span>
                      </button>
                      <button
                        mat-menu-item
                        (click)="
                          openDeleteDialog(
                            element.recordId,
                            element.subscriptionIdentifier
                          )
                        "
                      >
                        <mat-icon>delete</mat-icon><span>Delete</span>
                      </button>
                    </mat-menu>
                  </mat-cell>
                </ng-container>

                <mat-header-row
                  *matHeaderRowDef="displayedColumns"
                ></mat-header-row>
                <mat-row
                  *matRowDef="let row; columns: displayedColumns"
                ></mat-row>
                <tr class="mat-row" *matNoDataRow>
                  <td
                    class="mat-cell no-data-cell"
                    [attr.colspan]="displayedColumns.length"
                  >
                    <div class="no-data-container">
                      <mat-icon>inbox</mat-icon>
                      <p>No pending subscriptions found</p>
                    </div>
                  </td>
                </tr>
              </mat-table>

              <mat-paginator
                #pendingPaginator
                [pageSizeOptions]="[5, 10, 20]"
                showFirstLastButtons
              ></mat-paginator>
            </div>
          </mat-tab>
        </mat-tab-group>

        <button
          mat-flat-button
          color="primary"
          class="create-btn"
          (click)="navigateToCreate()"
        >
          <mat-icon>add</mat-icon> Create Subscription
        </button>
      </div>
    </div>
  </div>
</div>
